import isEmpty from 'lodash/fp/isEmpty';

export const notEmpty = a => !isEmpty(a);
